import config from "@/config";
import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        path: "/",
        name: "main",
        component: () => import("@/components/main/MainPage.vue"),
        children: [
            {
                path: "",
                name: "home",
                component: () => import("@/components/main/HomeTab.vue"),
            },
            {
                path: "products",
                name: "products",
                component: () => import("@/components/main/ProductTab.vue"),
            },
            {
                path: "products/:pageId",
                name: "product-detail",
                component: () => import("@/components/main/products/ProductDetailPage.vue"),
            },
            {
                path: "technology",
                name: "technology",
                component: () => import("@/components/main/TechnologyTab.vue"),
            },
            {
                path: "technology/:pageId",
                name: "technology-detail",
                component: () => import("@/components/main/technology/TechnologyDetailPage.vue"),
            },
            {
                path: "about",
                name: "about",
                component: () => import("@/components/main/AboutTab.vue"),
            },
            {
                path: "about/:pageId",
                name: "about-detail",
                component: () => import("@/components/main/about/AboutDetailPage.vue"),
            },
            {
                path: "media/main",
                name: "media",
                component: () => import("@/components/main/about/MediaPage.vue"),
            },
            {
                path: "media/detail",
                name: "media-detail",
                component: () => import("@/components/main/about/MediaDetailPage.vue"),
            },
            {
                path: "support",
                name: "support",
                component: () => import("@/components/main/SupportTab.vue"),
                children: [
                    {
                        path: "faq",
                        name: "faq",
                        component: () => import("@/components/main/support/FaqPage.vue"),
                    },
                    {
                        path: "downloads",
                        name: "downloads",
                        component: () => import("@/components/main/support/DownloadsPage.vue"),
                    },
                    {
                        path: "contact-us",
                        name: "contact-us",
                        component: () => import("@/components/main/support/ContactUsPage.vue"),
                    },
                    {
                        path: "demo-request",
                        name: "demo-request",
                        component: () => import("@/components/main/support/DemoRequestPage.vue"),
                    },
                ],
            },
            {
                path: "support/contact-us",
                name: "contact-us",
                component: () => import("@/components/main/support/ContactUsPage.vue"),
            },
            {
                path: "support/faq",
                name: "faq",
                component: () => import("@/components/main/support/FaqPage.vue"),
            },
            {
                path: "support/downloads",
                name: "downloads",
                component: () => import("@/components/main/support/DownloadsPage.vue"),
            },
            {
                path: "support/demo-request",
                name: "demo-request",
                component: () => import("@/components/main/support/DemoRequestPage.vue"),
            },
            {
                path: "member/sign-in",
                name: "sign-in",
                component: () => import("@/components/main/member/SignIn.vue"),
            },
            {
                path: "member/sign-in/:sns",
                name: "sign-in-sns",
                component: () => import("@/components/main/member/SignIn.vue"),
            },
            {
                path: "member/sign-up",
                name: "sign-up",
                component: () => import("@/components/main/member/SignUp.vue"),
            },
            {
                path: "member/userinfo-edit",
                name: "userinfo-edit",
                component: () => import("@/components/main/member/UserInfoEditPage.vue"),
            },
            {
                path: "userinfo",
                name: "userinfo",
                component: () => import("@/components/main/member/UserInfoPage.vue"),
                children: [
                    {
                        path: "account-setting",
                        name: "account-setting",
                        component: () => import("@/components/main/member/AccountSettingTab.vue"),
                    },
                    {
                        path: "shipping",
                        name: "shipping",
                        component: () => import("@/components/main/member/ShippingTab.vue"),
                    },
                    {
                        path: "my-orders",
                        name: "my-orders",
                        component: () => import("@/components/main/member/MyOrdersTab.vue"),
                    },
                ],
            },
        ],
    },
    {
        path: "/admin/login",
        name: "admin-login",
        component: () => import("@/components/admin/AdminLoginPage.vue"),
    },
    {
        path: "/admin",
        name: "admin",
        component: () => import("@/components/admin/AdminPage.vue"),
        children: [
            {
                path: "edit/:pageId",
                name: "admin-edit",
                component: () => import("@/components/admin/AdminEditPage.vue"),
            },
            {
                path: "edit-popup",
                name: "admin-edit-popup",
                component: () => import("@/components/admin/AdminEditPopupPage.vue"),
            },
            {
                path: "home",
                name: "admin-main",
                component: () => import("@/components/admin/AdminMainPage.vue"),
            },
            {
                path: "products",
                name: "admin-products",
                component: () => import("@/components/admin/AdminProductsPage.vue"),
            },
            {
                path: "support/faq",
                name: "admin-faq",
                component: () => import("@/components/admin/AdminFAQPage.vue"),
            },
            {
                path: "support/downloads",
                name: "admin-downloads",
                component: () => import("@/components/admin/AdminDownloadsPage.vue"),
            },
            {
                path: "support/contact-us",
                name: "admin-contact-us",
                component: () => import("@/components/admin/AdminContactUsPage.vue"),
            },
            {
                path: "demo/page",
                name: "admin-demo-page",
                component: () => import("@/components/admin/AdminDemoPage.vue"),
            },
            {
                path: "demo/list",
                name: "admin-demo-list",
                component: () => import("@/components/admin/AdminDemoListPage.vue"),
            },
            {
                path: "compare-products/manage-product",
                name: "manage-product",
                component: () => import("@/components/admin/AdminCompareProductsManage.vue"),
            },
            {
                path: "compare-products/add-template",
                name: "add-template",
                component: () => import("@/components/admin/AdminCompareProductsAddTemplate.vue"),
            },
            {
                path: "compare-products/comparison-specs",
                name: "comparison-specs",
                component: () => import("@/components/admin/AdminCompareProductsComparisonSpecs.vue"),
            },
            {
                path: "newsroom",
                name: "admin-newsroom",
                component: () => import("@/components/admin/AdminNewsroomPage.vue"),
            },
            {
                path: "settings",
                name: "admin-settings",
                component: () => import("@/components/admin/AdminSettingsPage.vue"),
            },
        ],
    },
];

const routeList = config.isLocalDevelopment
    ? routes
    : config.isUS
      ? routes.filter((route) => !route.path.startsWith("/admin"))
      : routes;

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routeList,
    scrollBehavior(to, from, savedPosition) {
        // 사용자가 브라우저의 뒤로가기/앞으로가기 버튼을 클릭한 경우
        if (savedPosition) {
            return savedPosition;
        } else {
            // 새 페이지로 이동하는 경우 스크롤을 맨 위로 이동
            return { top: 0 };
        }
    },
});

// 전역 이벤트 버스 생성 (메뉴 닫기 이벤트를 위한)
export const menuEventBus = {
    listeners: {},
    on(event, callback) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(callback);
    },
    emit(event) {
        if (this.listeners[event]) {
            this.listeners[event].forEach((callback) => callback());
        }
    },
};

// 라우트 변경 시 메뉴 닫기
router.beforeEach((to, from, next) => {
    menuEventBus.emit("closeMenu");
    next();
});

export default router;
